import api from "./api";
import UtilsUrl from "../utils/UtilsUrl";
import axios from "axios";

class ProductOrderService {
  //   addWarehouse(warehouseModel) {
  //     return api.post(UtilsUrl.warehouseURL() + "/addWarehouse", warehouseModel);
  //   }
  //   updateWarehouse(idUser, idWarehouse, warehouseModel) {
  //     return api.post(
  //       UtilsUrl.warehouseURL() +
  //         "/updateRealWarehouse/" +
  //         idUser +
  //         "/" +
  //         idWarehouse,
  //       warehouseModel
  //     );
  //   }

  getProductTransactionHistoryByFacture(idFacture, idUser) {
    return api.get(
      UtilsUrl.purchaseOrderURL() +
        "/getProductTransactionHistoryByFacture/" +
        idFacture +
        "/" +
        idUser
    );
  }

  getProductTransactionHistoryByBDC(idFacture, idUser) {
    return api.get(
      UtilsUrl.purchaseOrderURL() +
        "/getProductTransactionHistoryByBDC/" +
        idFacture +
        "/" +
        idUser
    );
  }
  getProductTransactionHistoryByPO(idPO, idUser) {
    return api.get(
      UtilsUrl.purchaseOrderURL() +
        "/getProductTransactionHistoryByPO/" +
        idPO +
        "/" +
        idUser
    );
  }
  getProductTransactionHistoryByWarhouse(idWarehouse, idUser) {
    return api.get(
      UtilsUrl.purchaseOrderURL() +
        "/getProductTransactionHistoryByWarhouse/" +
        idWarehouse +
        "/" +
        idUser
    );
  }
  getProductTransactionHistoryByWarhouseV2(idWarehouse, idUser,dd,df) {
    return api.get(
      UtilsUrl.purchaseOrderURL() +
        "/getProductTransactionHistoryByWarhouseV2/" +
        idWarehouse +
        "/" +
        idUser +
        "/" +
        dd +
        "/" +
        df
    );
  }
  getDevisSellOfLastMonth(idUser, isDeleted) {
    return api.get(
      UtilsUrl.documentURL() +
        "/getDevisSellOfLastMonth/" +
        idUser +
        "/" +
        isDeleted
    );
  }
  getBDCSellOfLastMonth(idUser, isDeleted) {
    return api.get(
      UtilsUrl.documentURL() +
        "/getBDCSellOfLastMonth/" +
        idUser +
        "/" +
        isDeleted
    );
  }
  getAllDevisSellByIdUserAndArchived(idUser, isDeleted) {
    return api.get(
      UtilsUrl.documentURL() +
        "/getAllDevisSellByIdUserAndArchived/" +
        idUser +
        "/" +
        isDeleted
    );
  }
  getAllBDCSellByIdUserAndArchived(idUser, isDeleted) {
    return api.get(
      UtilsUrl.documentURL() +
        "/getAllBDCSellByIdUserAndArchived/" +
        idUser +
        "/" +
        isDeleted
    );
  }
  getFactureSellOfLastMonth(idUser, isDeleted) {
    return api.get(
      UtilsUrl.documentURL() +
        "/getFactureSellOfLastMonth/" +
        idUser +
        "/" +
        isDeleted
    );
  }

  //   deleteWarehouseManager(idUser, idWarehouse, idManager) {
  //     return api.get(
  //       UtilsUrl.warehouseURL() +
  //         "/deleteWarehouseManager/" +
  //         idUser +
  //         "/" +
  //         idWarehouse +
  //         "/" +
  //         idManager
  //     );
  //   }
}

export default new ProductOrderService();
